export default __webpack_public_path__ + "static/media/homeDark.f20248ff.svg";